import { useState } from "react";
import { firestore, auth } from "../../../../firebase";
import {
  Card,
  CardContent,
  Button,
  TextField,
  Stack,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Grid,
  Typography,
  OutlinedInput,
  InputAdornment,
  FormControlLabel,
  FormGroup,
  Switch,
} from "@mui/material";
import { SelectChangeEvent } from "@mui/material/Select";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify"; // then this

const BsbsVerticalWall = ({ formData, setFormData }) => {
  // const [verticalWallOverlay, setVerticalWallOverlay] = useState("");
  // const [verticalWallCoating, setVerticalWallCoating] = useState("");
  // const [verticalWallStructure, setVerticalWallStructure] = useState("");
  // const [verticalWallCeiling, setVerticalWallCeiling] = useState("");
  // const [verticalWallSurface, setVerticalWallSurface] = useState("");
  // const [verticalWallNotes, setVerticalWallNotes] = useState("");

  // const handleSubmit = (e) => {
  //   if (
  //     verticalWallOverlay &&
  //     verticalWallCoating &&
  //     verticalWallStructure &&
  //     verticalWallCeiling &&
  //     verticalWallSurface &&
  //     verticalWallNotes
  //   ) {
  //     const newSite = {
  //       verticalWallOverlay,
  //       verticalWallCoating,
  //       verticalWallStructure,
  //       verticalWallCeiling,
  //       verticalWallSurface,
  //       verticalWallNotes,
  //     };
  //     firestore.collection("sites").add(newSite);
  //     setHorizontalWallCoating("");
  //     setHorizontalWallStructure("");
  //     setHorizontalWallCeiling("");
  //     setHorizontalWallSurface("");
  //     setHorizontalWallNotes("");
  //     setHorizontalWallOverlay("");
  //   }
  // };
  return (
    // <form onSubmit={handleSubmit} noValidate autoComplete="off">
    <>
      <Card sx={{ marginBottom: "30px" }}>
        <CardContent>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Typography variant="h5">
                Encoding the vertical wall (Before works)
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack spacing={2}>
                <FormControl fullWidth>
                  <InputLabel id="verticalWallCoatingSideRoom1-label">
                    Coating Side Room 1
                  </InputLabel>
                  <Select
                    fullWidth
                    // error={siteHousingTypeError}
                    labelId="verticalWallCoatingSideRoom1-label"
                    label="Coating Side Room 1"
                    id="verticalWallCoatingSideRoom1"
                    value={formData.verticalWallCoatingSideRoom1}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        verticalWallCoatingSideRoom1: e.target.value,
                      })
                    }
                  >
                    <MenuItem value="Enduit"> Enduit </MenuItem>
                    <MenuItem value="Simple plâques de plâtre, fixation rigide">
                      Simple plâques de plâtre, fixation rigide
                    </MenuItem>
                    <MenuItem value="Simple plâques de plâtre, fixation résiliente">
                      Simple plâques de plâtre, fixation résiliente
                    </MenuItem>
                    <MenuItem value="Simple plâques de plâtre, sur structure indépendante (sans absorbant)">
                      Simple plâques de plâtre, sur structure indépendante (sans
                      absorbant)
                    </MenuItem>
                    <MenuItem value="Simple plâques de plâtre, sur structure indépendante (avec absorbant)">
                      Simple plâques de plâtre, sur structure indépendante (avec
                      absorbant)
                    </MenuItem>
                    <MenuItem value="Double plâques de plâtre, fixation rigide">
                      Double plâques de plâtre, fixation rigide
                    </MenuItem>
                    <MenuItem value="Double plâques de plâtre, fixation résiliente">
                      Double plâques de plâtre, fixation résiliente
                    </MenuItem>
                    <MenuItem value="Double plâques de plâtre, sur structure indépendante (sans absorbant)">
                      Double plâques de plâtre, sur structure indépendante (sans
                      absorbant)
                    </MenuItem>
                    <MenuItem value="Double plâques de plâtre, sur structure indépendante (avec absorbant)">
                      Double plâques de plâtre, sur structure indépendante (avec
                      absorbant)
                    </MenuItem>
                  </Select>
                </FormControl>

                <FormControl fullWidth>
                  <InputLabel id="verticalWallStructure-label">
                    Structure
                  </InputLabel>
                  <Select
                    fullWidth
                    // error={siteHousingTypeError}
                    labelId="verticalWallStructure-label"
                    label="Structure"
                    id="verticalWallStructure"
                    value={formData.verticalWallStructure}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        verticalWallStructure: e.target.value,
                      })
                    }
                  >
                    <MenuItem value="Ossature bois simple (avec absorbant)">
                      Ossature bois simple (avec absorbant)
                    </MenuItem>
                    <MenuItem value="Ossature bois simple (sans absorbant)">
                      Ossature bois simple (sans absorbant)
                    </MenuItem>
                    <MenuItem value="Ossature bois simple (avec absorbant)">
                      Ossature bois simple (avec absorbant)
                    </MenuItem>
                    <MenuItem value="Ossature bois double (sans absorbant)">
                      Ossature bois double (sans absorbant)
                    </MenuItem>
                    <MenuItem value="Ossature bois double (avec absorbant)">
                      Ossature bois double (avec absorbant)
                    </MenuItem>
                    <MenuItem value="Ossature métallique simple (avec absorbant)">
                      Ossature métallique simple (avec absorbant)
                    </MenuItem>
                    <MenuItem value="Ossature métallique double (avec absorbant)">
                      Ossature métallique double (avec absorbant)
                    </MenuItem>
                    <MenuItem value="Maçonnerie lourde, simple">
                      Maçonnerie lourde, simple
                    </MenuItem>
                    <MenuItem value="Maçonnerie semi-lourde, simple">
                      Maçonnerie semi-lourde, simple
                    </MenuItem>
                    <MenuItem value="Maçonnerie légère, simple">
                      Maçonnerie légère, simple
                    </MenuItem>
                    <MenuItem value="Maçonnerie lourde, double">
                      Maçonnerie lourde, double
                    </MenuItem>
                    <MenuItem value="Maçonnerie semi-lourde, double">
                      Maçonnerie semi-lourde, double
                    </MenuItem>
                    <MenuItem value="Maçonnerie légère, double">
                      Maçonnerie légère, double
                    </MenuItem>
                    <MenuItem value="Maçonnerie (type inconnu), simple">
                      Maçonnerie (type inconnu), simple
                    </MenuItem>
                    <MenuItem value="Maçonnerie (type inconnu), double">
                      Maçonnerie (type inconnu), double
                    </MenuItem>
                    <MenuItem value="Béton préfab, prémurs ? Simple, double">
                      Béton préfab, prémurs ? Simple, double
                    </MenuItem>
                  </Select>
                </FormControl>

                <FormControl fullWidth>
                  <InputLabel id="verticalWallCoatingSideRoom2-label">
                    Coating Side Room 2
                  </InputLabel>
                  <Select
                    fullWidth
                    // error={siteHousingTypeError}
                    labelId="verticalWallCoatingSideRoom2-label"
                    label="Coating Side Room 2"
                    id="verticalWallCoatingSideRoom2"
                    value={formData.verticalWallCoatingSideRoom2}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        verticalWallCoatingSideRoom2: e.target.value,
                      })
                    }
                  >
                    <MenuItem value="Enduit"> Enduit </MenuItem>
                    <MenuItem value="Simple plâques de plâtre, fixation rigide">
                      Simple plâques de plâtre, fixation rigide
                    </MenuItem>
                    <MenuItem value="Simple plâques de plâtre, fixation résiliente">
                      Simple plâques de plâtre, fixation résiliente
                    </MenuItem>
                    <MenuItem value="Simple plâques de plâtre, sur structure indépendante (sans absorbant)">
                      Simple plâques de plâtre, sur structure indépendante (sans
                      absorbant)
                    </MenuItem>
                    <MenuItem value="Simple plâques de plâtre, sur structure indépendante (avec absorbant)">
                      Simple plâques de plâtre, sur structure indépendante (avec
                      absorbant)
                    </MenuItem>
                    <MenuItem value="Double plâques de plâtre, fixation rigide">
                      Double plâques de plâtre, fixation rigide
                    </MenuItem>
                    <MenuItem value="Double plâques de plâtre, fixation résiliente">
                      Double plâques de plâtre, fixation résiliente
                    </MenuItem>
                    <MenuItem value="Double plâques de plâtre, sur structure indépendante (sans absorbant)">
                      Double plâques de plâtre, sur structure indépendante (sans
                      absorbant)
                    </MenuItem>
                    <MenuItem value="Double plâques de plâtre, sur structure indépendante (avec absorbant)">
                      Double plâques de plâtre, sur structure indépendante (avec
                      absorbant)
                    </MenuItem>
                  </Select>
                </FormControl>
              </Stack>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack spacing={2}>
                <FormControl sx={{}} variant="outlined">
                  <OutlinedInput
                    id="verticalWallSurface"
                    value={formData.verticalWallSurface}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        verticalWallSurface: e.target.value,
                      })
                    }
                    endAdornment={
                      <InputAdornment position="end">m2</InputAdornment>
                    }
                    aria-describedby="verticalWallSurface"
                    inputProps={{
                      "aria-label": "surface",
                    }}
                  />
                </FormControl>

                <TextField
                  fullWidth
                  id="HorizontalWallNotes"
                  label="Additional Notes"
                  multiline
                  rows={4}
                  value={formData.verticalWallNotes}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      verticalWallNotes: e.target.value,
                    })
                  }
                />
              </Stack>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
};

export default BsbsVerticalWall;
